import { ISelfSubscribe, MulticastDelegate } from '@Common/Core/MulticastDelegate';
import CommandProvider from './CommandProvider';
import { Command, IToolbarGroup } from '@Common/ApplicationCore/Command';

export interface ICommandDispatcher {
    isDisabledCommand(command: string): boolean;

    isSupportCommands(category: string, command: string): boolean;

    processCommand(command: Command): boolean;

    getCommandValue(id: string): boolean | undefined;

    onDispatcherUpdated?: ISelfSubscribe<ICallback<{ onlyState: boolean }>>;
}

export class CommandController {
    private dispatchers: ICommandDispatcher[] = [];
    private readonly commandProvider = new CommandProvider();
    public readonly onRefresh = MulticastDelegate.create<ICallback<{ onlyState: boolean }>>();
    /*@deprecated*/
    public readonly onCommandExecuted = MulticastDelegate.create<ICallback<Command>>();
    private toolbarGroupCached: [ICommandDispatcher[], IToolbarGroup[]] = [null, null];

    constructor(root: JQuery) {
        $(root).on('keydown', e => {
            const command = this.getCommandByShortcut(e, true);
            if (command) {
                this.executeCommand(command);
                e.preventDefault();
                e.stopPropagation();
                return false;
            }
            return true;
        });
    }

    public getCommand(id: string, throwable: boolean = true): Command {
        return this.commandProvider.getCommand(id, throwable);
    }

    public getCommandByShortcut(e: JQuery.Event, globalCommands?: boolean): Command {
        return this.commandProvider.getCommandByShortcut(e, globalCommands);
    }

    public isDisabledCommands(commandId: string): boolean {
        for (const commandDispatcher of this.dispatchers) {
            if (commandDispatcher.isDisabledCommand(commandId)) {
                return true;
            }
        }
        return false;
    }

    public executeCommand(command: Command): void {
        if (command.toggle) {
            command.value = !command.value;
        }

        for (const commandDispatcher of this.dispatchers) {
            if (commandDispatcher.processCommand(command)) {
                break;
            }
        }

        this.onCommandExecuted(command);
    }

    public getToolbarGroups(disableCache: boolean = false): IToolbarGroup[] {
        const [prevDispatchers] = this.toolbarGroupCached;
        if (!_.isEqual(prevDispatchers, this.dispatchers) || disableCache) {
            this.toolbarGroupCached = [this.dispatchers, this.getToolbarGroupInner(this.dispatchers)];
        }
        return this.toolbarGroupCached[1];
    }

    private getToolbarGroupInner(dispatchers: ICommandDispatcher[]): IToolbarGroup[] {
        const groups: IToolbarGroup[] = this.commandProvider.getToolbarGroups();
        const isSupportedCommands = (groupName, commandId) => dispatchers.some(d => d.isSupportCommands(groupName, commandId));
        for (const group of groups) {
            group.items = _.filter(group.items, item => item === null || isSupportedCommands(group.name, item.id));
            group.items = _.reject(group.items, (value, index) => value === null && (index === 0 || group.items[index - 1] === null));
        }
        return groups.filter(group => group.items.length > 0);
    }

    public addDispatcher(dispatcher: ICommandDispatcher): void {
        this.dispatchers.push(dispatcher);
        if (dispatcher.onDispatcherUpdated) {
            dispatcher.onDispatcherUpdated(({ onlyState }) => {
                this.onRefresh({ onlyState });
            });
        }
        this.onRefresh({ onlyState: false });
    }

    public removeDispatcher(dispatcher: ICommandDispatcher): void {
        this.dispatchers = _.without(this.dispatchers, dispatcher);
        dispatcher.onDispatcherUpdated.clear();
    }

    public getCommandValue(id: string): boolean {
        const name = this.commandProvider.getCommandGroupName(id);
        for (const commandDispatcher of this.dispatchers) {
            if (commandDispatcher.isSupportCommands(name, id)) {
                return commandDispatcher.getCommandValue(id) === true;
            }
        }

        return false;
    }
}
